import { apiCMS } from "../helpers/apiHelper";
const cmsPath =
  "/content/render/false/type/json/query/+structureName:StaticPage%20+StaticPage.urltitle:";
const cmsPathEndPart =
  "deleted:false%20%20+live:true/orderby/modDate%20desc/limit/2/offset/0";
// build up url path for CMNS content
export const requestCMSContent = (
  screenName: string,
  languageId: number
): any => {
  const url =
    cmsPath +
    screenName +
    "%20+languageId:" +
    languageId +
    "%20+" +
    cmsPathEndPart;
  return apiCMS.get(url);
};
